<template>
  <div>
    <!--<h1>Edit {{ item && item['@id'] }}</h1>-->
    <!--<b-row>-->
      <!--<b-col>-->
        <!--<div v-if="created" class="alert alert-success" role="status">{{ created.title }} {{$t('notifications.created')}}.</div>-->
        <!--<div v-if="updated" class="alert alert-success" role="status">{{ updated.name }} {{$t('notifications.updated')}}.</div>-->
        <!--<div v-if="isLoading || deleteLoading" class="alert alert-info" role="status">{{$t('notifications.loading')}}...</div>-->
        <!--<div v-if="error" class="alert alert-danger" role="alert">-->
          <!--<span class="fa fa-exclamation-triangle" aria-hidden="true" /> {{ error }}-->
        <!--</div>-->
        <!--<div v-if="deleteError" class="alert alert-danger" role="alert">-->
          <!--<span class="fa fa-exclamation-triangle" aria-hidden="true" /> {{ deleteError }}-->
        <!--</div>-->
      <!--</b-col>-->
    <!--</b-row>-->
    <b-row>
      <b-col v-if="isLoading">
        <Loader size="md"></Loader>
      </b-col>
      <b-col v-else>
        <EXCMAgreementDeviceForm
                v-if="item"
                :type="2"
                :handle-submit="onSendForm"
                :handle-update-field="updateField"
                :values="item"
                :errors="violations"
                :initial-values="retrieved" />
      </b-col>
    </b-row>

    <!--<router-link-->
      <!--v-if="item"-->
      <!--:to="{ name: 'EXCMAgreementDeviceList' }"-->
      <!--class="btn btn-default">Back to list</router-link>-->
    <!--<button-->
      <!--class="btn btn-danger"-->
      <!--@click="del">Delete</button>-->
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import EXCMAgreementDeviceForm from './Form.vue'
import Loader from '../../Layout/Loader'
// import { checkPagePermission } from '@/utils/checkRoles.js'

export default {
  components: {
    EXCMAgreementDeviceForm,
    Loader
  },

  data () {
    return {
      routeName: '',
      item: {}
    }
  },

  props: {
    agreementDeviceId: {
      type: String,
      default: null
    }
  },

  // beforeCreate () {
  //   checkPagePermission('devices', 'EXCMAgreementDeviceUpdate')
  // },

  computed: {
    ...mapGetters({
      isLoading: 'excmagreementdevice/update/isLoading',
      error: 'excmagreementdevice/update/error',
      deleteError: 'excmagreementdevice/del/error',
      deleteLoading: 'excmagreementdevice/del/isLoading',
      created: 'excmagreementdevice/create/created',
      deleted: 'excmagreementdevice/del/deleted',
      retrieved: 'excmagreementdevice/update/retrieved',
      updated: 'excmagreementdevice/update/updated',
      violations: 'excmagreementdevice/update/violations'
    })
  },

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    deleted: function (deleted) {
      if (!deleted) {
        return
      }

      this.$router.push({ name: 'EXCMAgreementDeviceList' })
    },
    updated: function (updated) {
      if (this.routeName === 'EXCMAgreementShow') {
        this.$Swal({
          title: this.$t('notifications.updated'),
          type: 'success'
        })
        this.$store.state.modals.excmagreementdevice.update.updated = 1
        this.$store.state.modals.excmagreementdevice.update.close = 1
      }
    }
  },

  beforeDestroy () {
    this.reset()
  },

  created () {
    this.routeName = this.$route.name
    if (this.agreementDeviceId) {
      this.retrieve(decodeURIComponent(this.agreementDeviceId))
    } else {
      this.retrieve(decodeURIComponent(this.$route.params.id))
    }
  },

  methods: {
    ...mapActions({
      createReset: 'excmagreementdevice/create/reset',
      deleteItem: 'excmagreementdevice/del/del',
      delReset: 'excmagreementdevice/del/reset',
      retrieve: 'excmagreementdevice/update/retrieve',
      updateReset: 'excmagreementdevice/update/reset',
      update: 'excmagreementdevice/update/update',
      updateRetrieved: 'excmagreementdevice/update/updateRetrieved'
    }),

    del () {
      if (window.confirm('Are you sure you want to delete this excmagreementdevice ?')) {
        this.deleteItem(this.retrieved)
      }
    },

    reset () {
      this.updateReset()
      this.delReset()
      this.createReset()
    },

    onSendForm () {
      this.update()
    },

    updateField (field, value) {
      this.updateRetrieved({ [field]: value })
    }
  }
}
</script>
